import { FormControl, Validators } from '@angular/forms';
import {
  EoCheckboxConfig,
  EoCustomControlConfig,
  EoDropdownConfig,
  EoFormPanelConfig,
  EoInputConfig,
} from 'ngx-eo-web-components';
import { Confirmation } from 'primeng/api';
import { roles } from '../../shared/components/role-dropdown/role-dropdown.config';

export const header = 'Διαχείριση Χρηστών';

export const userFormPanel = new EoFormPanelConfig({
  name: 'user',
  panelContentStyleClass: 'grid',
  config: [
    new EoInputConfig({
      name: 'userName',
      styleClass: 'col-6',
      type: 'text',
      label: 'Username',
      control: new FormControl('', [Validators.required]),
      placeholder: 'Παρακαλώ συμπληρώστε το username του χρήστη',
      inputIcon: 'pi pi-user',
    }),
    new EoInputConfig({
      name: 'email',
      styleClass: 'col-6',
      type: 'email',
      label: 'Email',
      placeholder: 'Παρακαλώ συμπληρώστε το email του χρήστη',
      control: new FormControl('', [Validators.required, Validators.email]),
      inputIcon: 'pi pi-envelope',
    }),
    new EoInputConfig({
      name: 'name',
      styleClass: 'col-6',
      type: 'text',
      label: 'Όνομα',
      placeholder: 'Παρακαλώ συμπληρώστε το όνομα του χρήστη',
      control: new FormControl('', [Validators.required]),
    }),
    new EoInputConfig({
      name: 'surname',
      styleClass: 'col-6',
      type: 'text',
      label: 'Επώνυμο',
      placeholder: 'Παρακαλώ συμπληρώστε το επώνυμο του χρήστη',
      control: new FormControl('', [Validators.required]),
    }),
    new EoDropdownConfig({
      name: 'role',
      label: 'Ρόλος',
      placeholder: 'Επιλέξτε ένα ρόλο',
      styleClass: 'col-6',
      options: roles,
      optionLabel: 'label',
      optionValue: 'value',
      appendTo: 'body',
      control: new FormControl(null, [Validators.required]),
    }),
    new EoCustomControlConfig({
      name: 'hospital',
      label: 'Νοσοκομείο',
      styleClass: 'col-6',
      control: new FormControl(null, [])
    }),
    new EoCheckboxConfig({
      name: 'lockoutEnabled',
      styleClass: 'col-6 flex flex-column justify-content-center',
      label: 'Κλειδωμένος',
      control: new FormControl(null),
    }),
  ],
});

export const userFormConfig: EoFormPanelConfig[] = [userFormPanel];
